import React from 'react'
import { MessageSquare } from 'lucide-react'

function EmptyMessagesState() {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-gray-100">
        <MessageSquare className="w-8 h-8 text-gray-400" />
      </div>
      <p className="text-sm text-gray-500">Send a message to start the conversation</p>
    </div>
  )
}

export default EmptyMessagesState
